import { omniAtom } from "src/utils/atoms";
import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";

const prefix = "modals/storePlanogramRules";

export interface StorePlanogramRulesModalStoreProps {
  mode: "store";
  merchflowId: number;
  basePogId: number;
  isBasePogFavorited: boolean;
  storeCodes: string[];
  defaultHighDensityEnabled?: boolean;
}

export interface StorePlanogramRulesModalBaseProps {
  mode: "base";
  merchflowId: number;
  s2SolutionId: number;
  pog: PogNonCircular;
}

export type StorePlanogramRulesModalProps =
  | StorePlanogramRulesModalStoreProps
  | StorePlanogramRulesModalBaseProps;

export const storePlanogramRulesDataAtom = omniAtom({
  prefix,
  key: "data",
  value: null as StorePlanogramRulesModalProps | null,
});
